module.exports={
	"AvailableActions": [
		"Access",
		"Create",
		"Delete",
		"Read",
		"Update",
		"Approve",
		"Grant",
		"Associate",
		"Disassociate",
		"View",
		"Advanced"
	],
	"AvailablePermissionMap": {
		"AcademyContent": [ "Create", "Read", "Update", "Delete" ],
		"Module-ContractAdmin": [ "Access" ],
		"Module-FormsEditor": [ "Access" ],
		"Module-PlatformConfiguration": [ "Access" ],
		"Module-Internal": [ "Access" ],
		"Module-HeadLight": [ "Access" ],
		"Module-Materials": [ "Access" ],
		"Module-LIMS": [ "Access" ],
		"Module-SamplePlan": [ "Access" ],
		"Module-ApprovalWorkflowEditor": [ "Access" ],
		"Module-ApprovalWorkflowBindingEditor": [ "Access" ],
		"Module-EmailNotificationEditor": [ "Access" ],
		"Module-LabelTypeEditor": [ "Access" ],
		"Module-HEADLIGHT_ACADEMY": [ "Access" ],
		"Module-HEADLIGHT_FIELDBOOK": [ "Access" ],
		"Module-HEADLIGHT_PROJECT": [ "Access" ],
		"Module-HEADLIGHT_PROFILE": [ "Access" ],
		"Module-HEADLIGHT_CUSTOMERS": [ "Access" ],
		"Module-HEADLIGHT_TRACKER": [ "Access" ],
		"Module-HEADLIGHT_PORTAL": [ "Access" ],
		"Module-HEADLIGHT_VAULT": [ "Access" ],
		"Account": [ "Create", "Delete", "Read", "Update" ],
		"AccountBudget": [ "Create", "Delete", "Read", "Update" ],
		"AccountLedger": [ "Create", "Delete", "Read", "Update" ],
		"AccountType": [ "Create", "Delete", "Read", "Update" ],
		"AppData": [ "Create", "Delete", "Read", "Update" ],
		"Artifact": [ "Create", "Delete", "Read", "Update" ],
		"ArtifactType": [ "Create", "Delete", "Read", "Update" ],
		"ArtifactTypeSpecification": [ "Create", "Delete", "Read", "Update" ],
		"AssetClassification": [ "Create", "Delete", "Read", "Update" ],
		"AssetType": [ "Create", "Delete", "Read", "Update" ],
		"AssetTypeManifest": [ "Create", "Delete", "Read", "Update" ],
		"BidItem": [ "Create", "Delete", "Read", "Update" ],
		"BidItem-Organization": [ "Associate", "Disassociate" ],
		"BidItem-Project": [ "Associate", "Disassociate" ],
		"Category-Project": [ "Associate", "Disassociate" ],
		"Certification": [ "Create", "Delete", "Read", "Update" ],
		"CertificationType": [ "Create", "Delete", "Read", "Update" ],
		"ChangeOrder": [ "Approve", "Create", "Delete", "Read", "Update" ],
		"Comment": [ "Create", "Read", "Delete", "Update" ],
		"ConcreteAggregate": [ "Create", "Delete", "Read", "Update" ],
		"ConfigEntry": [ "Create", "Delete", "Read", "Update" ],
		"Contact": [ "Create", "Delete", "Read", "Update" ],
		"Contact-Organization": [ "Associate", "Disassociate" ],
		"Contact-Project": [ "Associate", "Disassociate" ],
		"Contract": [ "Create", "Delete", "Read", "Update" ],
		"ContractType": [ "Create", "Delete", "Read", "Update" ],
		"ContractTypeDefaultDate": [ "Create", "Delete", "Read", "Update" ],
		"ContractTypeDefaultFunding": [ "Create", "Delete", "Read", "Update" ],
		"Core": [ "Create", "Delete", "Read", "Update" ],
		"Customer": [ "Create", "Delete", "Impersonate", "Read", "Update" ],
		"Customer-Module": [ "Associate", "Disassociate" ],
		"CustomerTeam": [ "Read", "Update" ],
		"CustomMetadata": [ "Advanced" ],
		"DeliveryTicket": [ "Create", "Delete", "Read", "Update", "Approve" ],
		"Document-Comment": [ "Associate", "Disassociate" ],
		"Document-ElectronicSignature": [ "Associate", "Disassociate" ],
		"Document-Observation": [ "Associate", "Disassociate" ],
		"Document": [ "Create", "Delete", "Read", "Update" ],
		"DocumentApprovalLog": [ "Create", "Delete", "Read", "Update" ],
		"DocumentArchive": [ "Create" ],
		"DocumentArtifact": [ "Create", "Delete", "Read", "Update" ],
		"DocumentMetadata": [ "Create", "Delete", "Read", "Update" ],
		"DocumentArtifact-Document": [ "Associate", "Disassociate" ],
		"ElectronicSignature": [ "Create", "Delete", "Read", "Update" ],
		"ElectronicSignature-Comment": [ "Associate", "Disassociate" ],
		"EmailRule": [ "Create", "Delete", "Read", "Update" ],
		"EmailRuleSchedule": [ "Create", "Delete", "Read", "Update" ],
		"Entity-Poly": [ "Associate", "Disassociate" ],
		"EntityDestinations": [ "Configure" ],
		"DashboardAccess": [ "Configure" ],
		"Equipment": [ "Create", "Delete", "Read", "Update" ],
		"Equipment-Organization": [ "Associate", "Disassociate" ],
		"Equipment-Project": [ "Associate", "Disassociate" ],
		"EstimateSummary": [ "Create", "Delete", "Read", "Update" ],
		"FormAccess": [ "Configure" ],
		"Fund": [ "Create", "Delete", "Read", "Update" ],
		"Fund-Document": [ "Associate", "Disassociate" ],
		"Fund-Project": [ "Associate", "Disassociate" ],
		"Funding-Category": [ "Associate", "Disassociate" ],
		"FundingAdjustment": [ "Create", "Delete", "Read", "Update" ],
		"FundingCategory": [ "Create", "Delete", "Read", "Update" ],
		"FundingCategory-LineItem": [ "Associate", "Disassociate" ],
		"FundingCategory-Project": [ "Associate", "Disassociate" ],
		"FundingSource": [ "Create", "Delete", "Read", "Update" ],
		"FundingSource-Contract": [ "Associate", "Disassociate" ],
		"FundingSource-Fund": [ "Associate", "Disassociate" ],
		"FundingSource-FundingCategory": [ "Associate", "Disassociate" ],
		"FundingSource-LineItem": [ "Associate", "Disassociate" ],
		"FundingSource-Project": [ "Associate", "Disassociate" ],
		"Inspection": [ "Create", "Delete", "Read", "Update" ],
		"Team": [ "Create", "Delete", "Read", "Update" ],
		"TeamUserJoin": [ "Create", "Delete", "Read", "Update" ],
		"LabTeamJoin": [ "Create", "Delete", "Read", "Update" ],
		"DocumentAccessJoin": [ "Create", "Delete", "Read", "Update" ],
		"Inspection-Document": [ "Associate", "Disassociate" ],
		"Inspection-PhysicalAsset": [ "Associate", "Disassociate" ],
		"InspectionStatus": [ "Create", "Delete", "Read", "Update" ],
		"InspectionType": [ "Create", "Delete", "Read", "Update" ],
		"InspectionType-ReportNamedInstance": [ "Associate", "Disassociate" ],
		"Inspection-User": [ "Associate", "Disassociate" ],
		"Lab": [ "Create", "Delete", "Read", "Update" ],
		"LabMaterialAssignment": [ "Create", "Delete", "Read", "Update" ],
		"LabTestApproval": [ "Create", "Delete", "Read", "Update" ],
		"LabTestDefault": [ "Create", "Delete", "Read", "Update" ],
		"Lab-Project": [ "Associate", "Disassociate" ],
		"Lab-Sample": [ "Associate", "Disassociate" ],
		"Lab-User": [ "Associate", "Disassociate" ],
		"LineItem": [ "Create", "Delete", "Read", "Update" ],
		"LineItem-Lot": [ "Associate", "Disassociate" ],
		"LineItem-Organization": [ "Associate", "Disassociate" ],
		"LineItem-Project": [ "Associate", "Disassociate" ],
		"LineItem-Sample": [ "Associate", "Disassociate" ],
		"LineItemChangeOrder": [ "Approve", "Create", "Delete", "Read", "Update" ],
		"Location": [ "Create", "Delete", "Read", "Update" ],
		"Lot": [ "Create", "Delete", "Read", "Update" ],
		"ManifestSchema": [ "Create", "Delete", "Read", "Update" ],
		"ManifestSchemaPartial": [ "Create", "Delete", "Read", "Update" ],
		"ManifestSchema-ManifestSchemaPartial": [ "Associate", "Disassociate" ],
		"Material": [ "Create", "Delete", "Read", "Update" ],
		"Material-LineItem": [ "Associate", "Disassociate" ],
		"Material-Organization": [ "Associate", "Disassociate" ],
		"Material-PayItem": [ "Associate", "Disassociate" ],
		"MaterialsAudit": [ "Configure" ],
		"MaterialsFormDashboard": [ "Read" ],
		"MixDesign": [ "Create", "Delete", "Read", "Update" ],
		"MixDesignApproval": [ "Create", "Delete", "Read", "Update" ],
		"MixSpecification": [ "Create", "Delete", "Read", "Update" ],
		"MixSpecification-Material": [ "Associate", "Disassociate" ],
		"MixType": [ "Create", "Delete", "Read", "Update" ],
		"Module": [ "Create", "Delete", "Read", "Update" ],
		"Observation-Artifact": [ "Associate", "Disassociate" ],
		"Observation-Comment": [ "Associate", "Disassociate" ],
		"Observation-ElectronicSignature": [ "Associate", "Disassociate" ],
		"Observation-Organization": [ "Associate", "Disassociate" ],
		"Observation": [ "Create", "Delete", "Read", "Update" ],
		"ObservationApprovalLog": [ "Create", "Delete", "Read", "Update" ],
		"ObservationArchive": [ "Create" ],
		"ObservationManifest": [ "Create", "Delete", "Read", "Update" ],
		"ObservationManifest-Project": [ "Associate", "Disassociate" ],
		"ObservationRequirementSpecification": [ "Create", "Delete", "Read", "Update" ],
		"ObservationSet": [ "Create", "Delete", "Read", "Update" ],
		"ObservationSet-Observation": [ "Associate", "Disassociate" ],
		"ObservationTag": [ "Create", "Delete", "Read", "Update" ],
		"ObservationTag-Project": [ "Associate", "Disassociate" ],
		"Organization": [ "Create", "Delete", "Read", "Update" ],
		"Organization-Project": [ "Associate", "Disassociate" ],
		"OrganizationAddress": [ "Create", "Delete", "Read", "Update" ],
		"PartialPayEstimate": [ "Create", "Delete", "Read", "Update" ],
		"PartialPayment": [ "Create", "Delete", "Read", "Update" ],
		"PayItem": [ "Create", "Delete", "Read", "Update" ],
		"PaymentFundingSnapshot": [ "Create", "Delete", "Read", "Update" ],
		"PaymentFundingSnapshotHistory": [ "Create", "Delete", "Read", "Update" ],
		"PaymentForm": [ "Create", "Delete", "Read", "Update" ],
		"Permission": [ "Grant", "Read" ],
		"PhysicalAsset": [ "Create", "Delete", "Read", "Update" ],
		"PhysicalAssetDefect": [ "Create", "Delete", "Read", "Update" ],
		"PhysicalAssetElementType": [ "Create", "Delete", "Read", "Update" ],
		"PhysicalAssetMaterial": [ "Create", "Delete", "Read", "Update" ],
		"PlantMixApproval": [ "Create", "Delete", "Read", "Update" ],
		"PD": [ "Create", "Delete", "Read", "Update" ],
		"Product": [ "Create", "Delete", "Read", "Update" ],
		"ProductionPlant": [ "Create", "Delete", "Read", "Update" ],
		"ProductionPlantMaterialApproval": [ "Create", "Delete", "Read", "Update" ],
		"Program": [ "Create", "Delete", "Read", "Update" ],
		"Project": [ "Create", "Delete", "Read", "Update", "BulkDelete" ],
		"Project-ReportNamedInstance": [ "Associate", "Disassociate" ],
		"ProjectFile": [ "Create", "Delete", "Read", "Update" ],
		"ProjectFileFolder": [ "Create", "Delete", "Read", "Update" ],
		"ProjectOffice": [ "Create", "Delete", "Read", "Update" ],
		"ProvisionalProgressPayment": [ "Create", "Delete", "Read", "Update" ],
		"ProjectTagType": [ "Create", "Delete", "Read", "Update" ],
		"ProjectType": [ "Create", "Delete", "Read", "Update" ],
		"ReportArchetype": [ "Create", "Delete", "Read", "Update" ],
		"ReportNamedInstance": [ "Create", "Delete", "Read", "Update", "EditJSON" ],
		"Role": [ "Create", "Delete", "Read", "Update" ],
		"RoleContextMembership": [ "Create", "Delete", "Read", "Update" ],
		"RoleEdge": [ "Create", "Delete", "Read", "Update" ],
		"RolePermission": [ "Create", "Delete", "Read", "Update" ],
		"Sample": [ "Create", "Delete", "Read", "Update" ],
		"SampleLog": [ "Create", "Delete", "Read", "Update" ],
		"SamplePlanEntry": [ "Read", "Update" ],
		"SampleStatus": [ "Create", "Delete", "Read", "Update" ],
		"SampleListColumns": [ "Configure" ],
		"SampleLock": [ "Override" ],
		"SampleQRCode": [ "Configure" ],
		"SentEmail": [ "Read" ],
		"Source-Project": [ "Associate", "Disassociate" ],
		"SubLot": [ "Create", "Delete", "Read", "Update" ],
		"Support": [ "Agent", "Manage", "View" ],
		"Test": [ "Create", "Delete", "Read", "Update" ],
		"Test-Lab": [ "Associate", "Disassociate" ],
		"TestData": [ "Create", "Delete", "Read", "Update" ],
		"TestInstance": [ "Create", "Delete", "Read", "Update" ],
		"TestInstance-Document": [ "Associate", "Disassociate" ],
		"TestInstance-Lab": [ "Associate", "Disassociate" ],
		"TestInstance-Sample": [ "Associate", "Disassociate" ],
		"TestInstanceData": [ "Create", "Delete", "Read", "Update" ],
		"TestSpecification": [ "Create", "Delete", "Read", "Update" ],
		"TestSpecification-Material": [ "Associate", "Disassociate" ],
		"TestSpecificationRequirement": [ "Create", "Delete", "Read", "Update" ],
		"TestSpecificationSet": [ "Create", "Delete", "Read", "Update" ],
		"TestSpecificationSet-Test": [ "Associate", "Disassociate" ],
		"User": [ "Read", "Create", "Update" ],
		"User-Lab": [ "Associate", "Disassociate" ],
		"User-Project": [ "Associate", "Disassociate" ],
		"User-Role": [ "Associate", "Disassociate" ],
		"UserContextRole": [ "Create", "Delete", "Read", "Update" ],
		"UserEntityAction": [ "Create", "Delete", "Read", "Update" ],
		"UserPermission": [ "Create", "Delete", "Read", "Update" ],
		"UserManagementPermissionsDetail": [ "Read" ],
		"UserManagementPermissionsEdit": [ "Read" ]
	}
}
